const cursor = document.getElementById('cursor');
let cx = 0, cy = 0, tx = 0, ty = 0;

const FLAKE_SVG = `<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g stroke="#4df0ff" stroke-width="1.2" stroke-linecap="round">
    <line x1="10" y1="2" x2="10" y2="18"/>
    <line x1="3" y1="6" x2="17" y2="14"/>
    <line x1="3" y1="14" x2="17" y2="6"/>
    <line x1="10" y1="5" x2="8.2" y2="3.2"/>
    <line x1="10" y1="5" x2="11.8" y2="3.2"/>
    <line x1="10" y1="15" x2="8.2" y2="16.8"/>
    <line x1="10" y1="15" x2="11.8" y2="16.8"/>
  </g>
  <circle cx="10" cy="10" r="1.2" fill="#4df0ff"/>
</svg>`;

/* ── Move cursor ── */
document.addEventListener('mousemove', e => {
  tx = e.clientX;
  ty = e.clientY;
  if (++trailCooldown % 4 === 0) {
    spawnTrail(tx + (Math.random() - .5) * 14, ty + (Math.random() - .5) * 14);
  }
});

let trailCooldown = 0;

function animCursor() {
  cx += (tx - cx) * 0.22;
  cy += (ty - cy) * 0.22;
  cursor.style.transform = `translate(${cx - 18}px, ${cy - 18}px)`;
  requestAnimationFrame(animCursor);
}
animCursor();

/* ── Trail snowflakes ── */
function spawnTrail(x, y) {
  const el = document.createElement('div');
  el.style.cssText = `position:fixed;pointer-events:none;z-index:9998;left:${x - 5}px;top:${y - 5}px;width:${6 + Math.random() * 8}px;height:${6 + Math.random() * 8}px;animation:trailfade 1.2s ease-out forwards;filter:drop-shadow(0 0 4px rgba(77,240,255,.8))`;
  el.innerHTML = FLAKE_SVG;
  document.body.appendChild(el);
  setTimeout(() => el.remove(), 1200);
}

/* ── Hover scale ── */
document.addEventListener('mouseover', e => {
  if (e.target.closest('a, button')) cursor.classList.add('hover');
});
document.addEventListener('mouseout', e => {
  if (e.target.closest('a, button')) cursor.classList.remove('hover');
});

/* ── Click burst ── */
document.addEventListener('click', e => {
  cursor.classList.remove('click');
  void cursor.offsetWidth;
  cursor.classList.add('click');
  setTimeout(() => cursor.classList.remove('click'), 600);

  /* two ripple rings */
  ['700ms', '1100ms'].forEach((dur, i) => {
    const ring = document.createElement('div');
    ring.style.cssText = `position:fixed;pointer-events:none;z-index:9996;width:40px;height:40px;border-radius:50%;border:1.5px solid ${i === 0 ? '#4df0ff' : 'rgba(77,240,255,.5)'};left:${e.clientX - 20}px;top:${e.clientY - 20}px;animation:ringout ${dur} ease-out forwards`;
    document.body.appendChild(ring);
    setTimeout(() => ring.remove(), parseInt(dur));
  });

  /* burst snowflakes */
  for (let i = 0; i < 10; i++) {
    const angle = (i / 10) * Math.PI * 2 + Math.random() * .4;
    const dist = 60 + Math.random() * 50;
    const f = document.createElement('div');
    f.style.cssText = `position:fixed;pointer-events:none;z-index:9997;left:${e.clientX - 7}px;top:${e.clientY - 7}px;width:${10 + Math.random() * 10}px;height:${10 + Math.random() * 10}px;--dx:${Math.cos(angle) * dist}px;--dy:${Math.sin(angle) * dist + 20}px;animation:burstOut ${700 + Math.random() * 500}ms cubic-bezier(.2,.7,.3,1) forwards;filter:drop-shadow(0 0 6px rgba(77,240,255,.9))`;
    f.innerHTML = FLAKE_SVG;
    document.body.appendChild(f);
    setTimeout(() => f.remove(), 1300);
  }
});
/* ── Theme Toggle ── */
function burstFlakes(x, y) {
  const SVG = `<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g stroke="#4df0ff" stroke-width="1.2" stroke-linecap="round">
      <line x1="10" y1="2" x2="10" y2="18"/>
      <line x1="3" y1="6" x2="17" y2="14"/>
      <line x1="3" y1="14" x2="17" y2="6"/>
    </g>
    <circle cx="10" cy="10" r="1.2" fill="#4df0ff"/>
  </svg>`;
  for (let i = 0; i < 20; i++) {
    const angle = (i / 20) * Math.PI * 2;
    const dist = 60 + Math.random() * 60;
    const f = document.createElement('div');
    f.style.cssText = `position:fixed;pointer-events:none;z-index:9997;left:${x - 8}px;top:${y - 8}px;width:${10 + Math.random() * 10}px;height:${10 + Math.random() * 10}px;--dx:${Math.cos(angle) * dist}px;--dy:${Math.sin(angle) * dist}px;animation:burstOut ${800 + Math.random() * 600}ms cubic-bezier(.2,.7,.3,1) forwards;filter:drop-shadow(0 0 6px rgba(77,240,255,.9))`;
    f.innerHTML = SVG;
    document.body.appendChild(f);
    setTimeout(() => f.remove(), 1500);
  }
}

let isDark = false;

function toggleTheme() {
  isDark = !isDark;
  applyTheme(isDark);
  try { localStorage.setItem('muguklima-theme', isDark ? 'dark' : 'light'); } catch(e) {}
}

function applyTheme(dark) {
  const thumb = document.getElementById('ttThumb');
  const btn = document.getElementById('themeToggle');

  if (dark) {
    document.documentElement.removeAttribute('data-theme');
    if (thumb) {
      thumb.style.transform = 'translateX(0)';
      thumb.style.background = 'linear-gradient(135deg,#4df0ff,#3d8bff)';
      thumb.innerHTML = '❄';
    }
    if (btn) {
      btn.style.background = '#0e1218';
      btn.style.borderColor = '#242c37';
    }
  } else {
    document.documentElement.setAttribute('data-theme', 'light');
    if (thumb) {
      thumb.style.transform = 'translateX(26px)';
      thumb.style.background = 'linear-gradient(135deg,#0096c7,#0077b6)';
      thumb.innerHTML = '☀';
    }
    if (btn) {
      btn.style.background = '#eaf0f7';
      btn.style.borderColor = '#c5ccd6';
    }
  }
}

/* ── Apply saved theme instantly on every page load ── */
try {
  const saved = localStorage.getItem('muguklima-theme');
  if (saved === 'dark') { isDark = true; applyTheme(true); }
  else { isDark = false; applyTheme(false); }
} catch(e) {}